export default __webpack_public_path__ + "static/media/cancer-care-icon.10f6db5e.svg";